import { Controller } from 'stimulus'

export default class extends Controller {
  // Use outlets API once Stimulus 3.2 is released
  // https://github.com/hotwired/stimulus/pull/576
  controllerForElement(controller, element) {
    return this.application.getControllerForElementAndIdentifier(element, controller)
  }
}
